class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    $(".cart__checkout-button").attr("disabled", true)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    console.log(body)
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        console.log(this.getSectionsToRender());
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
    
        // Update all shipping-progress-fill elements
        var productProgressBar = $(".block__cart-drawer-progress-wrapper").html();
        $(".block__cart-drawer-progress-wrapper").html(productProgressBar);


        
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        /* Add this code to the cart change event in theme */
        document.querySelectorAll('.gift_product_in_cart cart-remove-button')?.forEach(function(button) {
          button?.click();
        });
        /* Add this code to the cart change event in theme */
        if(document.querySelectorAll('.block__drawer-gift-product-item-active:not(.deactive)')){
            let upchargeItems = [];
            document.querySelectorAll('.block__drawer-gift-product-item-active:not(.deactive)')?.forEach(function(button) {
              upchargeItems.push({
                id: button.getAttribute("data_id"),
                quantity: 1
              });
            });
    
            let formData = {
                'items': upchargeItems
              };
    
            if(upchargeItems.length){
              fetch('/cart/add.js', {
              body: JSON.stringify(formData),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest'
              },
              method: 'POST'
            })
            .then(response => response.json())
            .then(json => {
                 fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
                  .then((response) => response.text())
                  .then((responseText) => {
                      const cartid = 'CartDrawer';
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const destination = document.querySelector('#CartDrawer');
                      const source = html.getElementById(cartid);
                
                  if (source && destination) {
                      destination.innerHTML = source.innerHTML;
                  }
                
                  fetch('/?section_id=cart-icon-bubble')
                  .then((response) => response.text())
                  .then((itemcount) => {
                      const cartIconBubble = document.querySelector('#cart-icon-bubble');
                      if (cartIconBubble) {
                          cartIconBubble.innerHTML = itemcount; 
                          const drawer = document.querySelector('.drawer');
                          if (drawer) {
                              drawer.classList.remove('is-empty');
                          }
                      }
                  })
                  .catch((error) => {
                      console.error('Error fetching cart icon bubble:', error);
                  });
                  })
                  .catch((error) => {
                      console.error('Error updating cart:', error);
                  });
            })
            .catch(err => {
              console.error('Error adding product to cart:', err);
            });
          }
        }

        $(".cart__checkout-button").attr("disabled", false)
      });
  }







  

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

jQuery(document).on('click', '.block__cart-drawer-selling-option-box', function(event){
  event.preventDefault();
  jQuery(this).find("ul").slideToggle("subscribe");
});
jQuery(document).on('click', '.block__cart-drawer-selling-option-box ul li', function(){
  jQuery(".block__cart-drawer-selling-option-box ul li").removeClass("active");
  var drawerSellingText = jQuery(this).text();
  jQuery(this).parents(".block__cart-drawer-selling-option-box").find("p").html(drawerSellingText)
  jQuery(this).addClass("active");
  var cartItemSellingPlanID = jQuery(this).attr("data-value");
  var cartItemIndex = jQuery(this).closest('.cart-item').attr("item-data-index");
  var cartItemQty = jQuery(this).closest('.cart-item').find("quantity-input .quantity__input").val();
  updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty)
});

jQuery(document).on('click', '.block__cart-drawer-selling-plan-toggle', function(event){
  event.preventDefault();
  jQuery(this).toggleClass("subscribe");
  var cartItemIndex = jQuery(this).closest('.cart-item').attr("item-data-index");
  var cartItemQty = jQuery(this).closest('.cart-item').find("quantity-input .quantity__input").val();
  if(jQuery(this).hasClass("subscribe")){
    if(jQuery(this).parents(".block__cart-drawer-selling-plan").find(".block__cart-drawer-selling-option-box li").hasClass("subscribe")){
      var cartItemSellingPlanID = jQuery(this).parents(".block__cart-drawer-selling-plan").find(".block__cart-drawer-selling-option-box li.active").attr("data-value");
    } else {
      var cartItemSellingPlanID = jQuery(this).parents(".block__cart-drawer-selling-plan").find(".block__cart-drawer-selling-option-box ul li:first-child").attr("data-value");
    }
      updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty)
  } else {
    var cartItemSellingPlanID =  "";
    updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty)
  }
});
function updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty) {
  var formData = {
    'line': cartItemIndex,
    'selling_plan': cartItemSellingPlanID,  
    'quantity': cartItemQty
  };
  console.log("formData", formData)
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    updateCart();
    console.log('Done response', response)
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

jQuery(document).on('click', '.rebuy-button, .rebuy-button span', function() {
  var jQuerythis = jQuery(this); // Declare jQuerythis here
  var interval = setInterval(doStuff, 100);
  function doStuff() {
    if (!jQuery(".rebuy-button").hasClass("working")) {
      clearInterval(interval);
      setTimeout(function () {
        updateCart()    
      }, 1500);
  } 
  }
});



function updateCart() {

  fetch(window.Shopify.routes.root + '?section_id=cart-drawer').then((response) => response.text()).then((responseText) => {
      const cartid = 'CartDrawer';
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.querySelector('#CartDrawer');
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;
      jQuery.ajax({
          url: '/?section_id=cart-icon-bubble',
          type: 'GET',
          dataType: 'html',
          success: function (itemcount) {
              jQuery("#cart-icon-bubble").html(jQuery(itemcount).html());
              // jQuery(".cart-count-bubble").trigger("click");
              console.log('cart updated');
              jQuery(".drawer").removeClass("is-empty");
              jQuery("#cart-icon-bubble")[0].click()
              jQuery('[data-popup-item-add]').removeClass('loading');
              jQuery('[data-popup-item-add]').removeClass('disabled');
              jQuery('[data-popup-item-cancel]').removeClass('disabled');
              jQuery("[data-popup-item-cancel]").trigger("click");
            /* Add this code to the cart change event in theme */
    setTimeout(function() {
    if(document.querySelectorAll('.block__drawer-gift-product-item-active:not(.deactive)')){
            let upchargeItems = [];
            document.querySelectorAll('.block__drawer-gift-product-item-active:not(.deactive)')?.forEach(function(button) {
              upchargeItems.push({
                id: button.getAttribute("data_id"),
                quantity: 1
              });
            });
    
            let formData = {
                'items': upchargeItems
              };
    
            if(upchargeItems.length){
              fetch('/cart/add.js', {
              body: JSON.stringify(formData),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest'
              },
              method: 'POST'
            })
            .then(response => response.json())
            .then(json => {
                 fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
                  .then((response) => response.text())
                  .then((responseText) => {
                      const cartid = 'CartDrawer';
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const destination = document.querySelector('#CartDrawer');
                      const source = html.getElementById(cartid);
                
                  if (source && destination) {
                      destination.innerHTML = source.innerHTML;
                  }
                
                  fetch('/?section_id=cart-icon-bubble')
                  .then((response) => response.text())
                  .then((itemcount) => {
                      const cartIconBubble = document.querySelector('#cart-icon-bubble');
                      if (cartIconBubble) {
                          cartIconBubble.innerHTML = itemcount; 
                          const drawer = document.querySelector('.drawer');
                          if (drawer) {
                              drawer.classList.remove('is-empty');
                          }
                      }
                  })
                  .catch((error) => {
                      console.error('Error fetching cart icon bubble:', error);
                  });
                  })
                  .catch((error) => {
                      console.error('Error updating cart:', error);
                  });
            })
            .catch(err => {
              console.error('Error adding product to cart:', err);
            });
          }
        }
    }, 100);
          }
      });
  }); 
  
  
}


jQuery(document).on('click', '.tangent_add_to_cart_button', function() {
  var jQuerythis = jQuery(this); // Declare jQuerythis here
  var interval = setInterval(doStuff, 100);
  function doStuff() {
    if (jQuerythis.hasClass("added-to-cart-style")) {
        clearInterval(interval);
        setTimeout(function () {
          updateCart()    
        }, 1500);
    } 
  }
});